import Vue from 'vue';
import rootAppFactory from '../components/RootApp';

export default function () {
    const node = document.getElementById('activecampaign-for-woocommerce-app');

    if (!node) {
        return;
    }

    const root = rootAppFactory(node);

    new Vue(root);
}



// WEBPACK FOOTER //
// ./admin/src/js/scripts/mountApplication.js